export default "__VITE_ASSET__DeOS3nwZ__"